import React from "react";
import { Button, Space, TimePicker, List, Typography } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { Dayjs } from "dayjs";
import { TimeBlock } from "../../../types/admin/TeamTypes";
import { fromPickerValue, toPickerValue } from "../../../utils/schedule/wallClock";

const { Text } = Typography;

interface ScheduleBlockEditorProps {
	blocks: TimeBlock[];
	onChange: (blocks: TimeBlock[]) => void;
}

const ScheduleBlockEditor: React.FC<ScheduleBlockEditorProps> = ({ blocks, onChange }) => {
	const handleAddBlock = () => {
		const newBlock: TimeBlock = {
			id: crypto.randomUUID(),
			start: null,
			end: null,
		};
		onChange([...blocks, newBlock]);
	};

	const handleUpdateBlock = (index: number, field: "start" | "end", value: Dayjs | null) => {
		const updated = [...blocks];
		updated[index] = {
			...updated[index],
			[field]: fromPickerValue(value),
		};
		onChange(updated);
	};

	const handleRemoveBlock = (index: number) => {
		const updated = blocks.filter((_, i) => i !== index);
		onChange(updated);
	};

	return (
		<div>
			<List
				dataSource={blocks}
				locale={{ emptyText: "No time blocks defined" }}
				renderItem={(block, index) => (
					<List.Item
						actions={[
							<Button type="link" danger size="small" icon={<DeleteOutlined />} onClick={() => handleRemoveBlock(index)}>
								Remove
							</Button>,
						]}
					>
						<Space>
							<Text>From:</Text>
							<TimePicker value={toPickerValue(block.start)} onChange={(value) => handleUpdateBlock(index, "start", value)} format="h:mm A" use12Hours minuteStep={15} />
							<Text>To:</Text>
							<TimePicker value={toPickerValue(block.end)} onChange={(value) => handleUpdateBlock(index, "end", value)} format="h:mm A" use12Hours minuteStep={15} />
						</Space>
					</List.Item>
				)}
			/>
			<Button type="dashed" icon={<PlusOutlined />} onClick={handleAddBlock} style={{ marginTop: 8, width: "100%" }}>
				Add Time Block
			</Button>
		</div>
	);
};

export default ScheduleBlockEditor;